import { TreeItem } from '../store/types';

export const findInTree = (a: TreeItem[], treeId: string) =>
  a.findIndex(item => {
    return item.treeId === treeId;
  });

const findInDenies = (a: number[], id: number) => a.findIndex(item => item === id);

export const expandRow = (tree: TreeItem[], visibleTree: TreeItem[], rowIndex: number): TreeItem[] => {
  const id = visibleTree[rowIndex].treeId;
  const parentRowIndex = findInTree(tree, id);
  const parent = tree[parentRowIndex];
  const childNodes = [];

  let i = parentRowIndex + 1;
  while (i < tree.length && tree[i].level > parent.level) {
    if (tree[i].level === parent.level + 1) {
      childNodes.push(tree[i]);
    }
    i++;
  }
  visibleTree[rowIndex].isExpanded = true;
  visibleTree.splice(rowIndex + 1, 0, ...childNodes);

  return [...visibleTree];
};

export const collapseRow = (visibleTree: TreeItem[], rowIndex: number): TreeItem[] => {
  const item = visibleTree[rowIndex];
  const startIndex = rowIndex + 1;
  let stopIndex = -1;
  let i = startIndex;
  let endNotFound = true;

  while (endNotFound) {
    if (i === visibleTree.length) {
      stopIndex = i;
      endNotFound = false;
      continue;
    }

    if (visibleTree[i].level <= item.level) {
      stopIndex = i;
      endNotFound = false;
      continue;
    }

    visibleTree[i].isExpanded = false;
    i++;
  }
  item.isExpanded = false;
  visibleTree.splice(startIndex, stopIndex - startIndex);
  return [...visibleTree];
};

export const filterTree = (visibleTree: TreeItem[], denies: number[]): TreeItem[] => {
  if (!denies) {
    return visibleTree;
  }

  let i = 0;
  const filteredTree = [];
  while (i < visibleTree.length) {
    const current = visibleTree[i];
    const isDenied = findInDenies(denies, current.id) !== -1;

    if (!isDenied) {
      filteredTree.push(current);
      i++;
      continue;
    }

    let j = i + 1;
    while (j < visibleTree.length && current.level < visibleTree[j].level) {
      j++;
    }
    i = j;
  }

  return filteredTree;
};



// WEBPACK FOOTER //
// ./src/utils/treeSync.ts